export enum PharmacyManagementSystemIntegrationStatusEnum {
  Initial = 0,
  Created = 1,
  Invalid = 2,
}
